import { findData, formatDate } from "../../../../../../../utils/common-utils";

export const filterTimeLines = (slots, date) => {
  const formattedDate = formatDate(date);

  const filteredSlots = slots.find(({ date }) => date === formattedDate);

  return filteredSlots.slots;
};

export const getExcludeDates = (slots) => {
  const emptySlotDates = slots
    .filter(({ slots }) => !slots.length)
    .map(({ date }) => new Date(date));

  return emptySlotDates;
};

export const getSlot = (slots, slotId) => {
  const slotItem = findData(slots, "id", slotId);

  const { startTime: from, endTime: till, date, id } = slotItem;

  return {
    from,
    till,
    date,
    id,
  };
};
